module.exports = __webpack_public_path__ + "img/dllogo.e74a09a0.png";